module.exports = __webpack_public_path__ + "static/media/ha-fish.cbde7810.mp3";